import script from "./ButtonRoundedPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonRoundedPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonRoundedPrimary.vue?vue&type=style&index=0&id=0a517a95&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a517a95"]])

export default __exports__